export const AppRoutes = {
  AUTH: "/auth",
  LOGIN: "/auth/login",
  HOME: "/",
  DASHBOARD: "/dashboard",
  DICOM: "/dicom",
  SCAN_CENTRES: "/scan-centres",
  SCAN_CENTER_SUMMARY: "/scan-centers/:scanCenterId/summary",
  CASES: "/cases",
  CASE_DETAIL: "/cases/:caseId",
  CASE_DETAIL_GUEST: "/guest/cases/:caseId",
  SHARED_PAGE: "/shared_page",
  DOCTORS: "/doctors",
  REFERRING_DOCTORS: "/referring-doctors",
  SCAN_TYPES: "/scan-types",
  BODY_PARTS: "/body-parts",
  REPORT_TEMPLATES: "/report-templates",
  DOCTOR_SUMMARY: "/doctors/:doctorId/summary",
  ADMINS: "/admins",
  ISSUES: "/issues",
  PROFILE: "/profile",
  REPORTS_CREATE: "/ai/new_report",
  REPORTS_LIST: "/ai/reports",
  REPORT_DETAIL: "/ai/reports/:reportId",
  CASE_DUMMY: "/dummyCases",
};
